<template>
  <v-card class="mx-auto" min-height="250" outlined :loading="loading">
<!--       <template slot="progress">
        <v-progress-linear color="deep-purple" height="3" indeterminate></v-progress-linear>
      </template> -->
      <v-list-item three-line>
        <v-list-item-content>
          <div class="text-overline">{{categoria}}</div>
          <v-list-item-subtitle style="min-height: 32px;">{{descrizione}}</v-list-item-subtitle>
          <v-list-item-content style="min-height: 100px;">
            <v-list-item-title>
              <v-list-item-subtitle v-if="id ==='categorie'">
                E' necessario attendere il completamento delle procedure precedenti 
              </v-list-item-subtitle> 
              <v-file-input
                v-if="id !=='categorie'"
                class="mt-2 text-caption"
                accept=".zip"
                label="File Zip"
                multiple
                show-size
                outlined
                dense
                prepend-icon=""
                prepend-inner-icon="$file"
                :hint="nomefile"
                :persistent-hint="!!nomefile"
                @change="onChange">
              </v-file-input>
            </v-list-item-title>
            <!-- <v-list-item-title><v-switch v-model="aggiornaDb" label="Aggiorna il database" class="ml-3"></v-switch></v-list-item-title> -->
          </v-list-item-content>
        </v-list-item-content>
      </v-list-item>
      <file-list v-if="id !=='categorie'" :files="files" @delete="onDeleteFile" @refresh="getDirList"/>
      <v-switch v-if="categoria === 'Ordini'" v-model="soloExcel" class="ml-3" inset label="Solo generazione Excel (no movimenti)"></v-switch>
      <v-card-actions class="pt-0">
        <v-badge bordered :color="notAllowed ? 'error' : 'success'" :icon="icon" overlap :value="icon">
          <v-btn outlined text @click="onSeleziona" :disabled="disabled || notAllowed">{{comando}}</v-btn>
        </v-badge>
        <a v-if="soloExcel && elaborazioneConclusa" :href="righeFile" download class="ml-5">Scarica il file</a>
      </v-card-actions>
      <v-card-text>
        <div v-for="(m, index) in messaggi" :key="index">
          {{m}}
        </div>
      </v-card-text>
      <dialog-conferma
        :show="dialogConferma"
        :title="titoloConferma"
        :message="messaggioConferma"
        :confirmText="confirmText"
        :onlyOk="onlyOk"
        @dialog-confirm="onConferma"
        @dialog-cancel="dialogConferma=false; onlyOk=false"
      />
   <!-- </form> -->
  </v-card>
</template>

<script>
import DialogConferma from '@/components/dialogConferma'
import FileList from './fileList'
import benetton from '@/services/custom/benettonService'

export default {
  components: {
    DialogConferma,
    FileList
  },
  props: {
    id: String,
    dbRemote: String,
    categoria: String,
    descrizione: String,
    comando: {type: String, default: 'Seleziona'},
    disabled: Boolean,
    notAllowed: Boolean
/*     modello: String,
    cliente: Object */
  },
  data(vm) {
    return {
      loading: false,
      aggiornaDb: true,
      nomefile: '',
      dialogConferma: false,
      titoloConferma: '',
      messaggioConferma: '',
      confirmText: 'SI',
      onlyOk: false,
      onConferma: vm.selectConfirm,
      files: [],
      intervalStato: null,
      messaggi: null,
      soloExcel: false,
      elaborazioneConclusa: false
    }
  },
  watch:{
    categoria() {
      this.onRefresh()
    }
  },
  async mounted() {
    if (this.id !== 'categorie') {
      await this.getDirList()
    }
    this.onRefresh()
  },
  computed:{
    icon() {
      if (this.notAllowed) return 'mdi-lock'
      if (this.disabled) return 'mdi-check-outline'
      return ''
    },
    licenza() {
      return this.cliente && this.cliente.licenze[0]
    },
    righeFile() {
      return benetton.getPathFileRighe()
    }    
  },
  methods: {
      onRefresh() {
        this.verificaStatoElaborazione(this.categoria.toLowerCase())
      },     
    //async onSeleziona(e) {
      // this.$emit('select', this.id, this.nomefile, this.aggiornaDb, this.removeDb)
    //},
    operazioneEseguitaConfirm() {
      this.dialogConferma = false
      this.confirmText= 'SI'
      this.onlyOk = false
    },
    operazioneEseguita(messaggio) {
      this.titoloConferma = 'Operazione eseguita'
      this.messaggioConferma = messaggio || 'Operazione eseguita con successo ! '
      this.confirmText= 'OK'
      this.onlyOk = true
      this.onConferma = this.operazioneEseguitaConfirm
      this.dialogConferma = true
      this.loading = false
    },
    onSeleziona() {
/*       if (this.nomefile === '') {
        this.titoloConferma = 'Dati non completi'
        this.messaggioConferma = 'Varificare che i file siano già stati trasferiti prima di procedere!'
        this.confirmText= 'OK'
        this.onlyOk = true
        this.onConferma = this.operazioneEseguitaConfirm
        this.dialogConferma = true
        return
      } */
      this.messaggi = []
      this.titoloConferma = 'Procedura: ' + this.categoria
      this.messaggioConferma = 'Confermi esecuzione import dati ?'
      this.onConferma = this.selectConfirm
      this.dialogConferma = true
      // this.$emit('select',  this.id, this.nomefile, this.aggiornaDb, this.removeDb))
    },
    async selectConfirm() {
      this.loading = true
      this.dialogConferma = false

      if (this.categoria === 'Ordini') {
        // const soloExcel = true // TODO: mettere switch
        await benetton.importaOrdini(this.soloExcel)
      }
      if (this.categoria === 'Packing') {
        await benetton.importaPacking()
      }
      if (this.categoria === 'Categorie') {
        await benetton.generaCategorie()
      }      
      let messaggio = ''
      if (['ordini', 'packing', 'categorie'].includes(this.categoria.toLowerCase())) {
        messaggio = 'L\'operazione è stata schedulata!<br/><br/>L\'attività richiede alcuni minuti per il completamento e sarà eseguita in background.'
        this.verificaStatoElaborazione(this.categoria.toLowerCase())
      }
      
      this.operazioneEseguita(messaggio)
    },    
    async onChange(files) {
      if (!files || files.length === 0) {
        return
      }
      this.loading = true
      for (const file of files) {
        try {
          const form_data = new FormData();
          form_data.append('import_file', file, `${file.name}`)
          await benetton.inviaFileForm(form_data)
        } catch {

        }
      }
      await this.getDirList()
      this.loading = false
    },
    async getDirList() {
      try {
        this.files = await benetton.getFileList('root', this.id)
      } catch {
      }
    },
    async onDeleteFile(file) {
      await benetton.deleteFile(file)
      await this.getDirList()
    },
    verificaStatoElaborazione(tipo) {
      if (!['ordini', 'packing', 'categorie'].includes(tipo)) return
      this.intervalStato = setInterval(async () => {
        const stati = await benetton.statoElaborazione()
        const isRunning = stati[tipo]
        if (!isRunning) {
          this.loading = false
          // console.log(this.intervalStato)
          clearInterval(this.intervalStato)
          this.intervalStato = null
          await this.getDirList()
        } else {
          this.loading = true
        }
        const messaggi = stati.messaggi && stati.messaggi[tipo]
        if (messaggi) {
          this.messaggi = messaggi
          this.elaborazioneConclusa = messaggi.some(x => x === 'Elaborazione ordini conclusa')
        }

      }, 10000)
    }    
  }
}
</script>